import { environment } from "src/environments/environment";


class UtilsResource {

    constructor () {}

    /**
     * Print log in a console only when the app isn't in production
     *
     * @param args: any[] - console to print
    */
    static ShowLog(...args: any[]) {
        if (!environment.production) {
            for (let i = 0; i < args.length; i++) {
                args[i] = JSON.stringify(args[i]);
            }
            console.log(args);
        }
    }

    /**
     * Print log in a console with especial mark only when the app isn't in production
     *
     * @param title: String - console title
     * @param description?: String - console description
     * @param strColorBg?: String - console backgraund color - Default 'red'
     * @param strColorFont?: String - console text color - Default 'white'
     */
    static NSMarkLog(title: any, description?: any, strColorBg?: String, strColorFont?: String) {
        if (!description) {
            description = '';
        }
        if (!strColorBg) {
            strColorBg = 'yellow';
        }
        if (!strColorFont) {
            strColorFont = 'blue';
        }
        const printTitle = `%c ${JSON.stringify(title)}`;
        const printConfigure = `background:${strColorBg}; color:${strColorFont}`;

        UtilsResource.ShowLog(printTitle, printConfigure, JSON.stringify(description));
    }

    /**
     * Print log in a console with especial mark only when the app isn't in production
     *
     * @param description?: String - console description
     */
    static NSMarkLogError(title: any, description: any) {
        if (!description) {
            description = '';
        }
        const printTitle = `%c ERROR - ${JSON.stringify(title)}`;
        const printConfigure = `background:red; color:yellow`;

        UtilsResource.ShowLog(printTitle, printConfigure, JSON.stringify(description));
    }
}

export { UtilsResource };